import React from 'react';

import { SSRMediaQueryStyle, SSRMediaQueryProps } from './SSRMediaQuery.styles';

export const SSRMediaQuery: React.FC<SSRMediaQueryProps> = (props) => (
    <SSRMediaQueryStyle data-testid="ssr-media-query" {...props} />
);
